import { memo } from 'react'
import { CrewLink } from '../crewLink/crewLink'
import { getDefaultTabValue } from '@crew/utils/enum'
import { FileDetailListTabs } from 'enums/app'
import { EntityType } from '@crew/enums/domain'
import { CrewFileIcon } from '../crewFileIcon/crewFileIcon'

export type CrewFileNameProps = {
  fileId: string
  fileName: string
  entityType: EntityType
  entityRecordId?: string
  showDownload?: boolean
  className?: string
}

export const CrewFileName = memo((props: CrewFileNameProps) => {
  return (
    <div className="flex items-center gap-x-3 group">
      <div className="flex flex-row items-center gap-1">
        {/* file icon */}
        <div className="shrink-0">
          <CrewFileIcon fileName={props.fileName} />
        </div>

        {/* file name */}
        <CrewLink
          to={`/files/${props.fileId}/${getDefaultTabValue(
            FileDetailListTabs
          )}`}
          title={props.fileName}
          className={props.className ?? ''}
          draggable={false}
        >
          {props.fileName}
        </CrewLink>
      </div>
    </div>
  )
})
